export default __webpack_public_path__ + "static/media/No3Closed.8e8e7a6d.jpg";